import styled from "styled-components";
import spacing from "theme/spacing.module.scss";
import colors, {ColorType} from "theme/colors.module.scss";

export const LineTextWrapper = styled.div<{ $hasText: boolean, $smallMargin: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${({ $hasText }) => ($hasText ? spacing.spacing : '0')};
    margin-bottom: ${({ $smallMargin }) => ($smallMargin ? $smallMargin : spacing.spacing)};
    margin-top: ${({ $smallMargin }) => ($smallMargin ? $smallMargin : spacing.spacing)};

    p {
        min-width: fit-content;
    }
`;

export const Line = styled.div<{ $color?: ColorType }>`
    width: 100%;
    border-bottom: solid 1px ${({ $color }) => ($color ? colors[$color] : colors.text100)};
    float: left;
`;